/* jshint esversion: 6 */
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DisplaySettings from './display-settings';
import UserSettings from './user-settings.js';
const { __ } = wp.i18n;
import {
	ToggleControl,
	SelectControl,
	Dashicon,
	PanelBody,
	RangeControl,
	Button,
	TextControl,
	Panel,
	FormToggle,
	Modal,
	Popover,
	Tooltip,
	DateTimePicker,
} from '@wordpress/components';
const { Component, Fragment } = wp.element;
class ItemComponent extends Component {
	constructor() {
		super( ...arguments );
		this.state = {
			open: false,
			confirm: false,
		};
	}
	render() {
		const toggleClose = () => {
			if ( this.state.confirm === true ) {
				this.setState( { confirm: false } );
			}
		};
		const timeFormat = ( kadenceCustomizerConditionalData.timeFormat ? kadenceCustomizerConditionalData.timeFormat : 'g:i a' );
		const is12HourTime = /a(?!\\)/i.test(
			timeFormat
				.toLowerCase() // Test only the lower case a
				.replace( /\\\\/g, '' ) // Replace "//" with empty strings
				.split( '' ).reverse().join( '' ) // Reverse the string and test for "a" not followed by a slash
		);
		const checkShowRules = ( undefined !== this.props.item.show && '' !== this.props.item.show ? JSON.parse( this.props.item.show ) : [] )
		return (
			<div className={ `kadence-sorter-item ${ ( this.props.item.enabled ? 'item-is-enabled' : 'item-is-disabled' ) }` } data-id={ this.props.item.id } key={ this.props.item.id }>
				<div className="kadence-sorter-item-panel-header">
					<ToggleControl
						checked={ ( undefined !== this.props.item.enabled && '' !== this.props.item.enabled ? this.props.item.enabled : false ) }
						onChange={ ( value ) => this.props.toggleEnabled( value, this.props.index ) }
					/>
					<span className="kadence-sorter-title">
						{ ( undefined !== this.props.item.label && '' !== this.props.item.label ? this.props.item.label : __( 'Extra Header', 'kadence' ) ) }
					</span>
					<Tooltip text={ __( 'Expand Item Controls', 'kadence' ) }>
						<Button
							className="kadence-sorter-item-expand"
							onClick={ () => {
								this.setState( { open: ( this.state.open ? false : true ) } )
							} }
						>
							<Dashicon icon={ ( this.state.open ? 'arrow-up-alt2' : 'arrow-down-alt2' ) }/>
						</Button>
					</Tooltip>
				</div>
				{ this.state.open && (
					<div className="kadence-sorter-item-panel-content">
						<TextControl
							label={ __( 'Header Label', 'kadence' ) }
							value={ this.props.item.label ? this.props.item.label : '' }
							onChange={ ( value ) => {
								this.props.onChangeLabel( value, this.props.index );
							} }
						/>
						<PanelBody
							title={ ( '' == this.props.item.show || ( undefined !== this.props.item.show[0] && undefined !== this.props.item.show[0].rule && '' == this.props.item.show[0].rule ) ? __( 'Display Settings [UNSET]' ) :  __( 'Display Settings' ) ) }
							initialOpen={ false }
						>
							<DisplaySettings
								label={ __( 'Show On', 'kadence' ) }
								rules={ ( kadenceCustomizerConditionalData ? kadenceCustomizerConditionalData.display : '' ) }
								value={ ( undefined !== this.props.item.show && '' !== this.props.item.show ? this.props.item.show : '' ) }
								id={ 'kad_header_show_conditionals' }
								onChange={ ( val ) => {
									if ( ! val ) {
										this.props.onChangeShow( '', this.props.index );
									} else {
										this.props.onChangeShow( val, this.props.index );
									}
								} }
							/>
							{ checkShowRules && checkShowRules.length > 1 && (
								<div className={ 'all-show-rules' } style={ {
										marginTop:'20px',
									} }
								>
									<ToggleControl
										label={ __( 'All show rules must be true?', 'kadence' ) }
										checked={ ( undefined !== this.props.item.all_show && '' !== this.props.item.all_show ? this.props.item.all_show : false ) }
										onChange={ ( value ) => this.props.onChangeAllShow( value, this.props.index ) }
									/>
								</div>
							) }
							<div style={ {
									height: '30px',
								} }
							>
							</div>
							<PanelBody
								title={ __( 'Exclude Settings', 'kadence' ) }
								initialOpen={ false }
							>
								<DisplaySettings
									label={ __( 'Hide On', 'kadence' ) }
									rules={ ( kadenceCustomizerConditionalData ? kadenceCustomizerConditionalData.display : '' ) }
									id={ 'kad_header_hide_conditionals' }
									value={ ( undefined !== this.props.item.hide && '' !== this.props.item.hide ? this.props.item.hide : '' ) }
									onChange={ ( val ) => {
										if ( ! val ) {
											this.props.onChangeHide( '', this.props.index );
										} else {
											this.props.onChangeHide( val, this.props.index );
										}
									} }
								/>
							</PanelBody>
						</PanelBody>
						<PanelBody
							title={ ( '' == this.props.item.user || ( undefined !== this.props.item.user[0] && undefined !== this.props.item.user[0].role && '' == this.props.item.user[0].role ) ? __( 'User Settings [UNSET]' ) :  __( 'User Settings' ) ) }
							initialOpen={ false }
						>
							<UserSettings
								label={ __( 'Visible to', 'kadence-pro' ) }
								roles={ ( kadenceCustomizerConditionalData ? kadenceCustomizerConditionalData.user : '' ) }
								value={ ( undefined !== this.props.item.user && '' !== this.props.item.user ? this.props.item.user : '' ) }
								onChange={ ( val ) => {
									if ( ! val ) {
										this.props.onChangeUser( '', this.props.index );
									} else {
										this.props.onChangeUser( val, this.props.index );
									}
								} }
							/>
							<PanelBody
								title={ __( 'Exclude Visibility Settings', 'kadence' ) }
								initialOpen={ false }
							>
								<UserSettings
									label={ __( 'Hide visibility to', 'kadence-pro' ) }
									roles={ ( kadenceCustomizerConditionalData ? kadenceCustomizerConditionalData.user : '' ) }
									value={ ( undefined !== this.props.item.user_hide && '' !== this.props.item.user_hide ? this.props.item.user_hide : '' ) }
									onChange={ ( val ) => {
										if ( ! val ) {
											this.props.onChangeUserHide( '', this.props.index );
										} else {
											this.props.onChangeUserHide( val, this.props.index );
										}
									} }
								/>
							</PanelBody>
						</PanelBody>
						<PanelBody
							title={ __( 'Expires Settings', 'kadence-pro' ) }
							initialOpen={ false }
						>
							<ToggleControl
								label={ __( 'Enable Expires', 'kadence' ) }
								checked={ ( undefined !== this.props.item.enable_expires && '' !== this.props.item.enable_expires ? this.props.item.enable_expires : false ) }
								onChange={ ( value ) => this.props.onChangeEnableExpires( value, this.props.index ) }
							/>
							{ undefined !== this.props.item.enable_expires && this.props.item.enable_expires && (
								<Fragment>
									<h2 className="kt-meta-title">{ __( 'Expires', 'kadence' ) }</h2>
									<DateTimePicker
										currentDate={ ( undefined !== this.props.item.expires && '' !== this.props.item.expires ? this.props.item.expires : new Date() ) }
										onChange={ ( date ) => {
											this.props.onChangeExpires( date, this.props.index );
										} }
										is12Hour={ is12HourTime }
									/>
								</Fragment>
							) }
						</PanelBody>
						<div className="conditional-options-footer-options">
							{ this.state.confirm && (
								<Popover position="top right" className="kadence-popover-color kadence-popover-confirm" onClose={ toggleClose }>
									<div className="kadence-popover-add-confirm-remove">
										<p>{ __( 'Note, This will permanently remove all the header settings connected to this conditional header.', 'kadence' ) }</p>
										<Button
											className="kadence-sorter-item-remove"
											isDestructive
											onClick={ () => {
												this.setState( { confirm: false } );
												this.props.removeItem( this.props.item.id, this.props.index );
											} }
										>
											{ __( 'Confirm, Remove Header', 'kadence' ) }
											<Dashicon icon="no-alt"/>
										</Button>
									</div>
								</Popover>
							) }
							{ ! this.state.confirm && (
								<Button
									className="kadence-sorter-item-remove"
									isDestructive
									onClick={ () => {
										this.setState( { confirm: true } );
									} }
								>
									{ __( 'Remove Header', 'kadence' ) }
									<Dashicon icon="no-alt"/>
								</Button>
							) }
							<Button
								className="kadence-sorter-item-export"
								isTertiary
								onClick={ () => {
									this.props.onExport( this.props.item.id, this.props.index );
								} }
							>
								{ __( 'Export Header', 'kadence' ) }
							</Button>
						</div>
					</div>
				) }
			</div>
		);
	}
}
export default ItemComponent;
